export enum NotificationType {
    ERROR = 'error',
    SUCCESS = 'success',
    WARN = 'warn',
    CANCEL = 'cancel',
    MESSAGE = 'message',
    ALERT = 'alert',
    INFO = 'info',
    TaxErrorMessage = 'Order Total Mismatch with tax. Please try again'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/notification-types.enum.ts